import config from '../../config';

import { SentryErrorTracker } from './errorTracker';
import { ErrorTrackerFeature } from './errorTrackerFeature';

export const errorTrackerFeature = new ErrorTrackerFeature(config.logToServer);
export const errorTracker = new SentryErrorTracker(errorTrackerFeature);
export const captureExceptionInSentry = errorTracker.captureException.bind(errorTracker);
export const addBreadcrumbInSentry = errorTracker.addBreadcrumb.bind(errorTracker);
